import { axiosInstance } from '../axios/axios'

export const verifyOTP = async (email: string, otp: string) => {
    try {
        const payload = {
            email_address: email,
            otp: otp
        }
        const result = await axiosInstance.post('/verify-otp', payload)
        return { status: result.data.status, message: result.data.message }
    } catch (error) {
        console.log(error)
        return { status: 'failed', message: 'Something went wrong' }
    }
}

export const sendOTP = async (email: string) => {
    try {
        const payload = {
            email_address: email
        }
        await axiosInstance.post('/send-otp', payload)
        return { status: true }
    } catch (error) {
        console.log(error)
        return { status: false }
    }
}